import { useState, useEffect } from 'react';
import './Reviews.css';
import { getAllReviews, addReview, getAvgRating } from '../utils/reviewsStore';

function StarDisplay({ rating, size = 16 }) {
  return (
    <span className="star-display" style={{ fontSize: size }}>
      {[1,2,3,4,5].map(n => (
        <span key={n} style={{ color: n <= rating ? '#ffe1a4' : '#ddd' }}>★</span>
      ))}
    </span>
  );
}

export { StarDisplay };

export default function Reviews({ showAll = false }) {
  const [reviews, setReviews] = useState([]);
  const [form, setForm] = useState({ name: '', role: '', rating: 5, comment: '' });
  const [submitted, setSubmitted] = useState(false);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    setReviews(getAllReviews());
  }, []);

  const submit = () => {
    if (!form.name.trim() || !form.comment.trim()) return;
    const newReview = { ...form, date: new Date().toLocaleDateString('en-IN', { month: 'short', year: 'numeric' }) };
    const updated = addReview(newReview);
    setReviews(updated);
    setSubmitted(true);
    setForm({ name: '', role: '', rating: 5, comment: '' });
    setTimeout(() => { setSubmitted(false); setShowForm(false); }, 3000);
  };

  const avg = getAvgRating(reviews);
  const displayed = showAll ? reviews : reviews.slice(0, 3);

  return (
    <section className="reviews-section" id="reviews">
      <div className="container">
        <div className="reviews-header">
          <div>
            <span className="section-tag">Client Reviews</span>
            <h2 className="reviews-title">What Clients <span>Say About Aryan</span></h2>
            <p className="reviews-sub">Real feedback from real clients. Every project delivered with care.</p>
          </div>
          <div className="reviews-summary">
            <div className="reviews-avg">{avg}</div>
            <StarDisplay rating={Math.round(parseFloat(avg))} size={22} />
            <div className="reviews-count">{reviews.length} review{reviews.length !== 1 ? 's' : ''}</div>
            <button className="reviews-add-btn" onClick={() => setShowForm(!showForm)}>
              {showForm ? '✕ Cancel' : '+ Leave a Review'}
            </button>
          </div>
        </div>

        {showForm && (
          <div className="review-form-card">
            <h3>Share Your Experience</h3>
            <div className="review-form-grid">
              <div className="rf-fg">
                <label>Your Name *</label>
                <input placeholder="e.g. Rahul Sharma" value={form.name} onChange={e => setForm(p => ({...p, name: e.target.value}))} />
              </div>
              <div className="rf-fg">
                <label>Your Role / Company</label>
                <input placeholder="e.g. Startup Founder, Delhi" value={form.role} onChange={e => setForm(p => ({...p, role: e.target.value}))} />
              </div>
            </div>
            <div className="rf-fg">
              <label>Rating</label>
              <div className="star-picker">
                {[1,2,3,4,5].map(n => (
                  <span key={n} className={`star-pick${form.rating >= n ? ' active' : ''}`} onClick={() => setForm(p => ({...p, rating: n}))}>★</span>
                ))}
              </div>
            </div>
            <div className="rf-fg">
              <label>Your Review *</label>
              <textarea rows={4} placeholder="Tell others about your experience with Aryan..." value={form.comment} onChange={e => setForm(p => ({...p, comment: e.target.value}))} />
            </div>
            {submitted ? (
              <div className="review-success">✅ Thank you! Your review has been submitted.</div>
            ) : (
              <button className="review-submit-btn" onClick={submit}>Submit Review →</button>
            )}
          </div>
        )}

        <div className="reviews-grid">
          {displayed.length === 0 ? (
            <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: '40px 20px', color: '#888' }}>
              <div style={{ fontSize: 40, marginBottom: 12 }}>💬</div>
              <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>No reviews yet</div>
              <div style={{ fontSize: 14 }}>Be the first to share your experience with Aryan.</div>
            </div>
          ) : displayed.map((r, i) => (
            <div key={i} className="review-card">
              <div className="review-top">
                <div className="review-avatar">{r.name.charAt(0).toUpperCase()}</div>
                <div>
                  <div className="review-name">{r.name}</div>
                  <div className="review-role">{r.role}</div>
                </div>
                <div className="review-date">{r.date}</div>
              </div>
              <StarDisplay rating={r.rating} size={16} />
              <p className="review-comment">"{r.comment}"</p>
            </div>
          ))}
        </div>

        {!showAll && reviews.length > 3 && (
          <div className="reviews-see-all">
            <a href="/reviews" className="btn-outline">See All {reviews.length} Reviews →</a>
          </div>
        )}
      </div>
    </section>
  );
}
